import request from "@/utils/request";

export function getApiKeysList(data) {
  return request({
    url: "/api_keys",
    method: "post",
    data,
  });
}
export function createApiKey(data) {
  return request({
    url: "/api_keys/create",
    method: "post",
    data,
  });
}
export function updateApiKey(data) {
  return request({
    url: "/api_keys/update",
    method: "post",
    data,
  });
}
export function getApiKeyEndpoints() {
  return request({
    url: "/api_keys/endpoint",
    method: "get",
  });
}
export function getApiKeyLogs(data, option = {}) {
  return request({
    url: "/api_keys/logs",
    method: "post",
    data,
    ...option,
  });
}
export function lookupApiKeyLog(data, option = {}) {
  return request({
    url: "/api_keys/logs/lookup",
    method: "post",
    data,
    ...option,
  });
}
export function revealApiKey(data) {
  return request({
    url: "/api_keys/reveal",
    method: "post",
    data,
  });
}
export function deleteApiKey(data) {
  return request({
    url: "/api_keys/delete",
    method: "delete",
    data,
  });
}
